<template>
  <div
    v-if="isVisible"
    class="marketing-consent"
  >
    <div
      class="marketing-consent__overlay"
      @click="handleConsent(false)"
    ></div>
    <div class="marketing-consent__content">
      <h2 class="marketing-consent__title">Zgody marketingowe</h2>
      <p class="marketing-consent__message">
        Czy wyrażasz zgodę na otrzymywanie informacji marketingowych dotyczących naszych usług?
      </p>
      <div class="marketing-consent__buttons">
        <button
          class="marketing-consent__button marketing-consent__button--yes"
          :disabled="isLoading"
          @click="handleConsent(true)"
        >
          {{ isLoading ? 'Zapisywanie...' : 'Tak' }}
        </button>
        <button
          class="marketing-consent__button marketing-consent__button--no"
          :disabled="isLoading"
          @click="handleConsent(false)"
        >
          Nie
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { RoutePaths } from '../../Router/types/routePaths';
import { UserService } from '@/api/user/userService';
import { useUserStore } from '@/stores/userStore/userStore';

const router = useRouter();
const userStore = useUserStore();
const isVisible = ref(true);
const isLoading = ref(false);

const MARKETING_CONSENT_KEY = 'marketing_consent';

const handleConsent = async (consent: boolean) => {
  try {
    isLoading.value = true;

    if (consent) {
      await UserService.updateMarketingConsent(true);
      const user = userStore.getLoggedInUser;
      if (user) {
        userStore.setUser({ ...user, marketingConsent: true });
      }
      localStorage.setItem(MARKETING_CONSENT_KEY, 'true');
    }
  } catch (error) {
    console.error('Failed to update marketing consent:', error);
  } finally {
    isLoading.value = false;
    isVisible.value = false;
    if (!consent) {
      router.push(RoutePaths.calculators);
    }
  }
};
</script>

<style lang="scss" scoped>
.marketing-consent {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgb(0 0 0 / 50%);
  }

  &__content {
    position: relative;
    max-width: 500px;
    width: 90%;
    text-align: center;
    padding: 3rem;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgb(0 0 0 / 10%);
    z-index: 1001;
  }

  &__title {
    font-size: 2.5rem;
    color: #834920;
    margin-bottom: 2rem;
    font-weight: 600;
  }

  &__message {
    color: #666;
    margin-bottom: 3rem;
    line-height: 1.5;
    font-size: 1.8rem;
  }

  &__buttons {
    display: flex;
    gap: 2rem;
    justify-content: center;
  }

  &__button {
    padding: 1.2rem 3rem;
    border: none;
    border-radius: 8px;
    font-size: 1.8rem;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s ease;
    min-width: 150px;

    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }

    &--yes {
      background-color: #834920;
      color: white;

      &:hover:not(:disabled) {
        background-color: #6b3a1a;
      }
    }

    &--no {
      background-color: #e0e0e0;
      color: #333;

      &:hover:not(:disabled) {
        background-color: #d0d0d0;
      }
    }
  }
}
</style>
